import { render } from "./AdvancedSettingsModal.vue?vue&type=template&id=13acbc80&scoped=true"
import script from "./AdvancedSettingsModal.vue?vue&type=script&lang=js"
export * from "./AdvancedSettingsModal.vue?vue&type=script&lang=js"

import "./AdvancedSettingsModal.vue?vue&type=style&index=0&id=13acbc80&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chris\\Documents\\quizmegpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13acbc80"]])

export default __exports__